@for (key of socialsKeys; track $index) {
  @if (!!log && hasLog(key, log)) {
    <div
      [innerHTML]="normalizeLog(key, log) | changeLogsDiffHTML: socialsLookup : (getLookup(key) | async)"
    ></div>
  }
}
